// Per-document version history : GET /api/content/{contentId}/versions[/{versionId}].
//
// Every successful, changed save snapshots the new document state server-side. This
// client lists those snapshots (newest first) and fetches one version's full data so
// the editor can reload it locally (the operator still has to Save to make it current).
//
// Goes through the shared `axios` instance (NOT raw fetch) so the Auth0AxiosBridge
// interceptor attaches the admin Bearer token on deployed instances.
//
// NOTE: HAND-WRITTEN client : lives beside its consumer because `src/API/` is wiped and
// regenerated wholesale by the OpenAPI generator (same convention as contentHistoryClient.ts).
import axios from "axios";

const apiBase = (process.env.REACT_APP_API_URL ?? "").replace(/\/+$/, "");

export interface ContentVersion {
	id: number;
	contentId: string;
	schemaKey: string;
	language: string;
	dataHash: string;
	sizeBytes: number;
	authorEmail: string;
	changeSummary: string;
	action: string;
	createdAt: string;
}

export interface ContentVersionList {
	items: ContentVersion[];
	total: number;
	page: number;
	pageSize: number;
}

export interface ContentVersionDetail {
	version: ContentVersion;
	data: Record<string, any>;
}

export async function listContentVersions(
	contentId: string,
	page = 1,
	pageSize = 30
): Promise<ContentVersionList> {
	const r = await axios.get<ContentVersionList>(
		`${apiBase}/api/content/${encodeURIComponent(contentId)}/versions`,
		{ params: { page, pageSize }, withCredentials: true }
	);
	return r.data ?? { items: [], total: 0, page, pageSize };
}

export async function getContentVersion(
	contentId: string,
	versionId: number
): Promise<ContentVersionDetail> {
	const r = await axios.get<ContentVersionDetail>(
		`${apiBase}/api/content/${encodeURIComponent(contentId)}/versions/${versionId}`,
		{ withCredentials: true }
	);
	return r.data;
}
